var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeatureBlockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 3,
    fill: "#7349DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81109 2.54348C6.87335 2.36437 7.12665 2.36437 7.18891 2.54348L8.12988 5.25051C8.15734 5.32952 8.23108 5.3831 8.31471 5.3848L11.18 5.44319C11.3696 5.44706 11.4479 5.68796 11.2968 5.80253L9.01302 7.53395C8.94636 7.58449 8.91819 7.67118 8.94241 7.75124L9.77231 10.4944C9.82722 10.6759 9.62229 10.8248 9.46664 10.7164L7.11424 9.07949C7.04557 9.03171 6.95443 9.03171 6.88576 9.07949L4.53336 10.7164C4.37771 10.8248 4.17278 10.6759 4.22769 10.4944L5.05759 7.75124C5.08181 7.67118 5.05364 7.58449 4.98698 7.53395L2.70322 5.80253C2.55211 5.68797 2.63039 5.44706 2.81997 5.44319L5.68529 5.3848C5.76892 5.3831 5.84266 5.32952 5.87012 5.25051L6.81109 2.54348Z",
    fill: "#F9E6F2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeatureBlockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "feature_block_icon.16094f72911256e633df69cacb75c3f0.svg";